import React from "react";
import a23logo from "../assets/a23_avatar_logo.png";
import close from "../assets/close.png";
import { connect } from "react-redux";
import { toggleModalAction,pokerAmountToA23Transfer,toggleAlertAction,a23ToPokerAmountTransfer } from '../redux/actions/userAction'
import {POKER_TDS_INFO} from "../Strings"
import Progress from "../models/ShowProgress";


class A23BalanceToPokerTransfer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token:window.sessionStorage["token"],
      channel:window.sessionStorage["channel"],
      isTransferBtnClick:true,
      //message:"",
      //btntext:"",
      //status:false
    };
    //this.A23BalanceToPokerTransfer = this.A23BalanceToPokerTransfer.bind(this)
  }
  componentWillMount() {
    //for Dynamic Token
    this.setState({token:window.sessionStorage["token"]})
    this.setState({channel:window.sessionStorage["channel"]})
  }

 componentDidMount(){
    document.body.style.overflow = 'hidden';
    this.setState({token:window.sessionStorage["token"]})
    this.setState({channel:window.sessionStorage["channel"]})
  }

   a23balancetoPokerbalanceTransfer(){
     this.props.handleUserTDSInfoRes()
     this.props.toggleModalAction(false)
   }
 

  render() {
    return (
      <div >
        <div class="relative absolute--fill flex justify-center items-center center left-1 right-1 white w7 ">
          <img
              class="absolute black nt4  left-0 top-0 right-0 h3 w3 center white flex justify-center items-center  z-9999 "
              src={a23logo} alt="no"
            ></img>
            <div
              className="center ph3 br2 ba pa1 b--black-10 flex flex-column"
              style={{backgroundColor:"#fffdea",color:"#032146",bordercolor:"#EABF6979",paddingTop: "1rem", borderRadius:"10px" }}
            >
              <div className="db pt0 f6 mt1 ">
                <img
                  class="absolute top-0 right-0 pa2"
                  style={{width:"23px", height:"23px"}}
                  src={close}
                  alt="no "
                  onClick={()=>this.props.toggleModalAction(false)}
                ></img>
                 <div className="w-100 db f6 tc">
                 <h4 className="mt0 fw4 f4 text-bold mt3" style={{color:"#032146"}} >{POKER_TDS_INFO.POKER_TDS_INFO_HEADER} </h4>
                
                  {<div className="mb2"><span className="f5 text">{POKER_TDS_INFO.POKER_BALANCE_A23_TEXT_MSG1}</span> <span  className="f5 text">&#8377; {this.props.amount} </span> <span className="f5 text">{POKER_TDS_INFO.POKER_BALANCE_A23_TEXT_MSG2}</span></div>}
                  {this.state.isTransferBtnClick?(<div className="pt2 mb2"><button className='ph4 pv2 tc center bw0 f5 fw4 dib br2 btn-green btn-green-login white' 
                   style={{ height: "auto" }} type='submit' onClick={()=>this.a23balancetoPokerbalanceTransfer()}>{POKER_TDS_INFO.POKER_TDS_TRANSFER}</button></div>):(<div className="mt2 mb2"><button className='ph4 pv2 tc center bw0 f5 fw4 dib br2 btn btn-grey  white o-70' 
                   style={{ height: "auto" }} type='submit'>{POKER_TDS_INFO.POKER_TDS_TRANSFER}</button></div>)}
                 </div>
                 </div>
                 </div>
          </div>
{/* )} */}
</div>
     
    );
  }
}
const mapStateToProps = state => ({
  userState: state.userState
});

export default connect(
  mapStateToProps,
  { toggleModalAction,pokerAmountToA23Transfer,toggleAlertAction,a23ToPokerAmountTransfer}
)(A23BalanceToPokerTransfer);
